import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full py-12 px-margin-page bg-surface-container-lowest border-t border-primary/10">
        <div className="max-w-container-max mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
            <a href="https://www.linkedin.com/in/dineshkumar-nataraj-a83ba2192/" target="_blank" rel="noreferrer" className="text-primary font-bold text-lg tracking-tight">DINESHKUMAR</a>
            <div className="flex items-center gap-8">
                <a className="text-on-surface-variant hover:text-primary transition-all font-semibold text-xs uppercase tracking-widest"
                    href="https://www.linkedin.com/in/dineshkumar-nataraj-a83ba2192/" target="_blank" rel="noreferrer">LinkedIn</a>
                <a className="text-on-surface-variant hover:text-primary transition-all font-semibold text-xs uppercase tracking-widest"
                    href="https://gitlab.com/dinesh_kumar_dk" target="_blank" rel="noreferrer">GitLab</a>
                <a className="text-on-surface-variant hover:text-primary transition-all font-semibold text-xs uppercase tracking-widest"
                    href="mailto:dineshnataraj345@outlook.com">Email</a>
                <a className="text-on-surface-variant hover:text-primary transition-all font-semibold text-xs uppercase tracking-widest"
                    href="https://gitlab.com/dinesh_kumar_dk" target="_blank" rel="noreferrer">Source Code</a>
            </div>
            <div className="text-on-surface-variant/60 text-sm font-medium">
                © 2024 Dineshkumar Nataraj. Built with Precision.
            </div>
        </div>
    </footer>
  );
};

export default Footer;
